export default "__VITE_ASSET__BnJkGWIw__"